import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import { ButtonPopover } from 'components/common';
import TierOneSupportContent from './TierOneSupportContent';

const anchorOrigin = { horizontal: 'center', vertical: 'top' };
const transformOrigin = { vertical: 'top', horizontal: 'center' };

const TierOneSupport = ({ fspId }) => {
  const [appendContent, setAppendContent] = useState(false);

  const handleClick = () => {
    if (appendContent === false) {
      setAppendContent(true);
    }
  };

  return (
    <ButtonPopover
      anchorOrigin={anchorOrigin}
      onClick={handleClick}
      title="FSP Support"
      transformOrigin={transformOrigin}
      variant="outlined"
    >
      {appendContent && <TierOneSupportContent fspId={fspId} />}
    </ButtonPopover>
  );
};

TierOneSupport.propTypes = {
  fspId: PropTypes.number.isRequired,
};

export default memo(TierOneSupport);
